import { requestApi } from 'api/api'
import { v4 as uuidv4 } from 'uuid'
import {
  RefundAuthRequest,
  RefundAuthResponse,
  RefundFeePayload,
  RefundFeeResponse,
  RefundPayload,
  RefundResponse,
} from 'types/refund'

export const postRefundFeeEstimate = ({
  data,
  transactionReference,
}: RefundFeePayload): Promise<RefundFeeResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `/payment/v1/payins/${transactionReference}/refund/estimate`,
    method: 'POST',
    data,
    headers: {
      'x-idempotency-key': uuidv4(),
    },
  })
}

export const postRefund = ({
  data,
  transactionReference,
  twoFactorEnabled,
}: RefundPayload): Promise<RefundResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `/payment/v1/payins/${transactionReference}/refund`,
    method: 'POST',
    data,
    headers: {
      'x-idempotency-key': uuidv4(),
      ...(!!twoFactorEnabled && { 'x-tag': 'merchant-portal' }),
    },
  })
}



export const postRefundAuth = (data: RefundAuthRequest): Promise<RefundAuthResponse> => {
  return requestApi({
    url: '',
    baseUrl: data?.mfaCallbackUrl,
    method: 'POST',
    data: {
      challenge: data?.challenge,
      tokenResponse: data?.tokenResponse,
    },
    headers: {
      'x-idempotency-key': uuidv4(),
    },
  })
}
